export default __webpack_public_path__ + "static/media/skype.d75f510b.png";